const GUIDELINES_KEY = "cf-guidelines-accepted";
const NOTIFICATION_PROMPT_KEY = "cf-notification-prompt-seen";

const getUserKey = (key: string, userId: number) => `${key}:${userId}`;

export const hasAcceptedGuidelines = (userId: number): boolean => {
  return localStorage.getItem(getUserKey(GUIDELINES_KEY, userId)) === "true";
};

export const setGuidelinesAccepted = (userId: number): void => {
  localStorage.setItem(getUserKey(GUIDELINES_KEY, userId), "true");
};

export const hasSeenNotificationPrompt = (userId: number): boolean => {
  return (
    localStorage.getItem(getUserKey(NOTIFICATION_PROMPT_KEY, userId)) === "true"
  );
};

export const setNotificationPromptSeen = (userId: number): void => {
  localStorage.setItem(getUserKey(NOTIFICATION_PROMPT_KEY, userId), "true");
};
